import React from 'react';
import { Navbar } from 'react-bootstrap';

export default function Header() {
  return (
    <Navbar
      expand="lg"
      style={{
        backgroundColor: '#c9c9c9ff',
        padding: '0.5rem 1rem',
        height: 'auto',      
        minHeight: '100px',   
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center w-100"
        style={{ height: '100%' }}
      >
        {/* Logo izquierda */}
        <img
          src="/images/escudo.png"
          alt="Escudo"
          style={{
            height: '80px',  
            width: 'auto',
          }}
        />

        {/* Texto centrado */}
        <h4
          className="text-center mb-0"
          style={{
            color: '#000',
            fontWeight: 'bold',
          }}
        >
          Prefectura Naval Argentina
        </h4>

        {/* Logo derecha */}
        <img
          src="/images/logo_pna.png"
          alt="Logo PNA"
          style={{
            height: '80px',   
            width: 'auto',
          }}
        />
      </div>
    </Navbar>
  );
}
